import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAppInfo } from '../hooks/useVersion';

/**
 * Development Environment Banner
 *
 * Sticky-bottom in-flow strip shown only when environment === "development".
 * Sticks to the viewport bottom while the user scrolls, then releases into
 * normal flow at the document bottom so layout chrome below it (the Admin
 * sidebar version, the Inspector page footer) stays visible. The parent
 * column controls width - in AdminLayout this is the main content column
 * (sidebar stays clear); in InspectorLayout it spans the wrapper.
 */
const DevEnvironmentBanner: React.FC = () => {
  const { version, environment } = useAppInfo();

  if (environment !== 'development') {
    return null;
  }

  return (
    <Box
      className="no-print"
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        backgroundColor: '#FFE082',
        borderTop: '1px solid #FFB74D',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 1,
        boxShadow: '0 -1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: '12px',
          color: 'rgba(0, 0, 0, 0.7)',
          fontWeight: 500,
          letterSpacing: '0.5px',
        }}
      >
        🔧 Development Environment - v{version || 'Loading...'}
      </Typography>
    </Box>
  );
};

export default DevEnvironmentBanner;